import React from "react";
import { useSelector } from "react-redux";
import { userProfile } from "../redux/reducers/profileReducer";
import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";
// import { userProfile } from "../redux/reducers/profileReducer";

interface ProtectedRouteProps {
  element: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {

  // const profile = useSelector(userProfile);

  // const token = profile.token?.length
  // ? profile.token
  // : localStorage.getItem("token");


  return element ;  
};

export default ProtectedRoute;
